import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import ManagerService from '@/services/manager.service';
import { ManagerState } from '@/store/modules/manager/index';
import {
  APPROVE_ALL_FORMS,
  APPROVE_FORM,
  APPROVE_SELECTED_FORMS,
  CREATE_ADP_UPDATE_FILE,
  UNDO_MARK_AS_UPDATE,
  CREATE_MASKIT_UPDATE_FILE,
  CUBE_SEARCH_OBJECT,
  DELETE_FORM,
  DELETE_MANUAL_FORM,
  FORMS_SEARCH,
  FORMS_SEARCH_OBJECT,
  GENERATE_COMPARE_RESULT_SEARCH_REPORT,
  GENERATE_CUBE_DETAILS_REPORT,
  GENERATE_DETAILED_FORMS_REPORT,
  GENERATE_EMPTY_FORM_101_AS_PDF,
  GENERATE_FORM_CHANGES_REPORT,
  GENERATE_FORMS_SEARCH_REPORT,
  GENERATE_GROUP_TYPE_EXPORT_EVENTS_REPORT,
  GENERATE_MANAGERS_REPORT,
  GET_CUBE_DETAILS,
  GET_CUBES_FORM101_DATA,
  GET_CUBES_FORM_101_CHANGES,
  GET_CUBES_INFO,
  GET_CUBES_STATS,
  GET_EMPLOYEE_EMAIL,
  GET_FORM101_OFFICES_LIST,
  GET_FORM101_UNITS_LIST,
  GET_FORM_101_CHANGES,
  GET_FORM_101_FILTERS_LIST,
  GET_FORM_101_REJECT_REASON,
  GET_FORM_101_STATUSES_LIST,
  GET_FORM_DATA,
  GET_FORM_STATUS_HISTORY_LIST,
  GET_ID_NUMBER_FIELDS,
  GET_MANAGER_DOCUMENT_CONTENT,
  GET_MANAGER_DOCUMENT_LIST,
  GET_STATISTICS,
  GET_STATISTICS_OFFICES,
  MANAGER_GENERATE_FORM_101_AS_PDF,
  MANAGER_GET_FORM_101_AS_PDF,
  MANAGER_GET_MANUAL_FORM_101_AS_PDF,
  MANAGER_ROOT,
  MANUAL_UPDATE_IPT,
  MARK_AS_IGNORE,
  REJECT_FORM,
  RESET_PASSWORD,
  SAVE_FORM_101_CHANGES_NOTES,
  SET_ADP_MODE,
  SET_APPROVE_FORM_ERRORS,
  SET_CUBE_DETAILS,
  SET_CUBE_DETAILS_ERRORS,
  SET_CUBE_SEARCH_OBJECT,
  SET_CUBES_INFO,
  SET_CUBES_INFO_ERRORS,
  SET_CUBES_STATS,
  SET_CUBES_STATS_ERRORS,
  SET_CUBES_STATS_LOADING,
  SET_EMPLOYEE_EMAIL,
  SET_FORM101_CHANGES,
  SET_FORM101_OFFICES_LIST,
  SET_FORM101_SECTION_NAMES,
  SET_FORM101_SECTION_NOTES,
  SET_FORM101_UNITS_LIST,
  SET_FORM101_UNITS_LOADING,
  SET_FORM_101_CHANGES_NOTES_ERRORS,
  SET_FORM_101_FILTERS_LIST,
  SET_FORM_101_REJECT_REASON,
  SET_FORM_101_STATUSES_LIST,
  SET_FORM_STATUS_HISTORY,
  SET_FORMS_RESULT_DATA,
  SET_FORMS_SEARCH_ERRORS,
  SET_FORMS_SEARCH_OBJECT,
  SET_ID_NUMBER_FIELDS_DATA,
  SET_MANAGER_LOADING,
  SET_MANUAL_UPDATE_IPT_MODAL_ERRORS,
  SET_MASKIT_MODE,
  SET_OPEN_APPROVE_FORMS_MODAL,
  SET_OPEN_APPROVE_FORMS_MODAL_ERRORS,
  SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS,
  SET_OPEN_MANUAL_FORM_MODAL,
  SET_OPEN_MANUAL_UPDATE_IPT_MODAL,
  SET_OPEN_REMOVE_FORM_MODAL,
  SET_OPEN_REMOVE_FORM_MODAL_ERRORS,
  SET_REJECT_FORM_ERRORS,
  SET_RESET_PASSWORD_LOADING,
  SET_SELECTED_FORMS_TO_APPROVE,
  SET_STATISTICS,
  SET_STATISTICS_ERRORS,
  SET_STATISTICS_OFFICES,
  UNDO_MARK_AS_IGNORE,
  UPDATE_IPT,
  UPLOAD_MANUAL_FORM,
} from '@/types/managerForm.types';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { eventsHub } from '@/main';
import {
  FORM_ROOT,
  SET_FORM101_DATA,
  SET_FORM101_ID,
  SET_FORM101_META_DATA,
  SET_FORM_REJECTED_REASON,
  SET_OPEN_APPROVE_FORM_DIALOG,
  SET_OPEN_FORM_101_CHANGES_DIALOG,
  SET_OPEN_REJECT_FORM_DIALOG,
} from '@/types/form.types';
import { ManagerResetPasswordRequest } from '@/models/manager/ManagerResetPasswordRequest';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { Utils } from '@/globals/Utils';
import { FormsSearchRequest } from '@/models/manager/ManagerFormsSearchRequest';
import { FileMimeType } from '@/models/FileMimeType';
import { Document } from '@/models/form/Documents.model';
import { CubesSelectedEmpsRequestModel } from '@/models/manager/CubesSelectedEmpsRequest.model';
import { finalize } from 'rxjs/operators';
import { Grid } from '@/models/Grid.model';
import { CompareResultSearchRequestModel } from '@/models/manager/CompareResultSearchRequest.model';
import { RequestPayload } from '@/models/base/RequestPayload';
import { DOCUMENT_ROOT, SET_DOCUMENTS, SET_DOCUMENTS_ERRORS, SET_LOADING } from '@/types/documents.types';
import { AUTHENTICATION_ROOT, USER_DETAILS } from '@/types/authentication.types';

export const managerService = new ManagerService();

export const actions: ActionTree<ManagerState, RootState> = {

  [GET_FORM101_OFFICES_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    managerService.getForm101OfficesList()
      .subscribe(
        (data: any) => {
          const indexNum = rootGetters[AUTHENTICATION_ROOT + USER_DETAILS].indexNum;
          const formsSearchObject = rootGetters[MANAGER_ROOT + FORMS_SEARCH_OBJECT];
          const cubeSearchObject = rootGetters[MANAGER_ROOT + CUBE_SEARCH_OBJECT];
          const officeNum = data.form101OfficesList[0].code;
          commit(SET_FORM101_OFFICES_LIST, data.form101OfficesList);
          if (data.form101OfficesList.length === 1 && indexNum !== 6500) {
            commit(SET_FORMS_SEARCH_OBJECT, { ...formsSearchObject, officeNum });
            commit(SET_CUBE_SEARCH_OBJECT, { ...cubeSearchObject, officeNum });
            dispatch(GET_FORM101_UNITS_LIST, officeNum);
          }
        },
      );
  },

  [GET_FORM101_UNITS_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    officeNum: number,
  ) => {
    commit(SET_FORM101_UNITS_LOADING, true);
    managerService.getForm101UnitsList(officeNum)
      .pipe(
        finalize(() => commit(SET_FORM101_UNITS_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          commit(SET_FORM101_UNITS_LIST, data.form101UnitsList);
        },
      );
  },

  [GET_FORM_101_FILTERS_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    managerService.getForm101FiltersList()
      .subscribe(
        (data: any) => {
          commit(SET_FORM_101_FILTERS_LIST, data.form101FiltersList);
        },
      );
  },

  [GET_ID_NUMBER_FIELDS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formsSearchObject: Form101SearchModel,
  ) => {
    managerService.getIdNumberFields()
      .subscribe(
        (data) => {
          commit(SET_ID_NUMBER_FIELDS_DATA, data);
        },
        error => commit(SET_FORMS_SEARCH_ERRORS, error.messages),
      );
  },

  [FORMS_SEARCH]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    commit(SET_FORMS_RESULT_DATA, {} as Grid);
    managerService.formsSearch(state.form101SearchObject)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data) => {
          commit(SET_FORMS_RESULT_DATA, data);
        },
        error => commit(SET_FORMS_SEARCH_ERRORS, error.messages),
      );
  },

  [GET_STATISTICS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    managerService.getStatistics()
      .subscribe(
        (data: any) => {
          commit(SET_STATISTICS, data.form101Statistics);
        },
        error => commit(SET_STATISTICS_ERRORS, error.messages),
      );
  },

  [GET_STATISTICS_OFFICES]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    managerService.getStatisticsOffices()
      .subscribe(
        (data: any) => {
          commit(SET_STATISTICS_OFFICES, data.form101OfficesList);
        },
        error => commit(SET_STATISTICS_ERRORS, error.messages),
      );
  },

  [APPROVE_FORM]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.approveForm(formData)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.approveFormSuccess'),
          });
          eventsHub.$router.push({
            name: 'search-employees',
            params: { triggerSearch: 'true', statusCode: '' + state.form101SearchObject.statusCode },
          });
          commit(FORM_ROOT + SET_OPEN_APPROVE_FORM_DIALOG, false, { root: true });
        },
        error => commit(SET_APPROVE_FORM_ERRORS, error.messages),
      );
  },

  [REJECT_FORM]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.rejectForm(formData)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.rejectFormSuccess'),
          });
          eventsHub.$router.push({
            name: 'search-employees',
            params: { triggerSearch: 'true', statusCode: '' + state.form101SearchObject.statusCode },
          });
          commit(FORM_ROOT + SET_OPEN_REJECT_FORM_DIALOG, false, { root: true });

        },
        error => commit(SET_REJECT_FORM_ERRORS, error.messages),
      );
  },

  [GET_FORM_101_REJECT_REASON]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.getForm101RejectReason(formData)
      .subscribe(
        (data: any) => {
          commit(SET_FORM_101_REJECT_REASON, data.rejectReason);
          commit(FORM_ROOT + SET_FORM_REJECTED_REASON, data.rejectReason, { root: true });
        },
        error => commit(SET_REJECT_FORM_ERRORS, error.messages),
      );
  },

  [DELETE_FORM]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    commit(SET_OPEN_REMOVE_FORM_MODAL_ERRORS, []);
    managerService.deleteForm(formData)
      // .pipe(
      //   finalize(() => commit(SET_REMOVE_FORM_LOADING, false)),
      // )
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.formRemoveModal.formRemoveModalSuccessfullyMessage'),
          });
          commit(SET_OPEN_REMOVE_FORM_MODAL, false);
          eventsHub.$root.$emit('fetchSearch', state.form101SearchObject);
        },
        error => commit(SET_OPEN_REMOVE_FORM_MODAL_ERRORS, error.messages),
      );
  },

  [DELETE_MANUAL_FORM]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    commit(SET_OPEN_REMOVE_FORM_MODAL_ERRORS, []);
    managerService.deleteManualForm(formData)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.formRemoveModal.formRemoveModalSuccessfullyMessage'),
          });
          commit(SET_OPEN_REMOVE_FORM_MODAL, false);
          eventsHub.$root.$emit('fetchSearch', state.form101SearchObject);
        },
        error => commit(SET_OPEN_REMOVE_FORM_MODAL_ERRORS, error.messages),
      );
  },

  [GET_FORM_STATUS_HISTORY_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    commit(SET_FORM_STATUS_HISTORY, {});
    managerService.getFormStatusHistoryList(formData)
      .subscribe(
        (data) => {
          const res = {
            results: data.statusHistoryList,
            resultCount: data.statusHistoryList.length,
          };
          commit(SET_FORM_STATUS_HISTORY, res);
          commit(SET_MANAGER_LOADING, false);

        },
      );
  },

  [GET_FORM_101_CHANGES]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    commit(SET_FORM101_CHANGES, {});
    managerService.getForm101Changes(formData)
      .pipe(
        finalize(() => {
          if (formData.openForm101ChangesDialog) {
            commit(FORM_ROOT + SET_OPEN_FORM_101_CHANGES_DIALOG, true, { root: true });
          }
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(SET_FORM101_CHANGES, data.form101Changes);
          commit(SET_FORM101_SECTION_NAMES, data.sectionNames);
          if (data.sectionNotes) {
            commit(SET_FORM101_SECTION_NOTES, data.sectionNotes);
          }
        },
        error => commit(SET_FORM_101_CHANGES_NOTES_ERRORS, error.messages),
      );
  },

  [GET_CUBES_FORM_101_CHANGES]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    commit(SET_FORM101_CHANGES, {});
    managerService.getForm101Changes(formData)
      .pipe(
        finalize(() => {
          if (formData.openForm101ChangesDialog) {
            commit(FORM_ROOT + SET_OPEN_FORM_101_CHANGES_DIALOG, true, { root: true });
          }
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(SET_FORM101_CHANGES, data.form101Changes);
          commit(SET_FORM101_SECTION_NAMES, data.sectionNames);
          if (data.sectionNotes) {
            commit(SET_FORM101_SECTION_NOTES, data.sectionNotes);
          }
        },
        error => commit(SET_FORM_101_CHANGES_NOTES_ERRORS, error.messages),
      );
  },

  [SAVE_FORM_101_CHANGES_NOTES]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.saveForm101ChangesNotes(formData)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.form101Changes.addNoteSuccess'),
          });
        },
        error => commit(SET_FORM_101_CHANGES_NOTES_ERRORS, error.messages),
      );
  },

  [GET_FORM_101_STATUSES_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    managerService.getForm101StatusesList()
      .subscribe(
        (data) => {
          commit(SET_FORM_101_STATUSES_LIST, data.form101StatusesList);
        },
      );
  },

  [GET_FORM_DATA]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.getFormData(formData)
      .pipe(
        finalize(() => {
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(FORM_ROOT + SET_FORM101_DATA, data.formData, { root: true });
          commit(FORM_ROOT + SET_FORM101_ID, data.formData.formId, { root: true });
          commit(FORM_ROOT + SET_FORM101_META_DATA, data.formMetadata, { root: true });
          commit(SET_MANAGER_LOADING, true);
          if (formData.routeToWizard) {
            eventsHub.$router.push({ name: 'wizard' });
          }
        },
      );
  },

  [GET_CUBES_FORM101_DATA]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.getFormData(formData)
      .pipe(
        finalize(() => {
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(FORM_ROOT + SET_FORM101_DATA, data.formData, { root: true });
          commit(FORM_ROOT + SET_FORM101_ID, data.formData.formId, { root: true });
          commit(FORM_ROOT + SET_FORM101_META_DATA, data.formMetadata, { root: true });
          commit(SET_MANAGER_LOADING, true);
          if (formData.routeToWizard) {
            eventsHub.$router.push({ name: 'wizard' });
          }
        },
      );
  },

  [RESET_PASSWORD]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    managerResetPasswordRequest: ManagerResetPasswordRequest,
  ) => {
    commit(SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS, []);
    managerService.resetPassword(managerResetPasswordRequest)
      .pipe(
        finalize(() => commit(SET_RESET_PASSWORD_LOADING, false)),
      )
      .subscribe(
        (data) => {
          commit(SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, false);
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.formResetPasswordModal.formResetPasswordSuccessfullyMessage'),
          });
        },
        error => commit(SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS, error.messages),
      );
  },

  [GET_EMPLOYEE_EMAIL]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    managerForm101Data: ManagerForm101Data,
  ) => {
    managerService.getEmployeeEmail(managerForm101Data)
      .subscribe(
        (data) => {
          commit(SET_EMPLOYEE_EMAIL, data.email);
        },
      );
  },

  [MANAGER_GET_FORM_101_AS_PDF]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: ManagerForm101Data,
  ) => {
    managerService.getForm101AsPdf(formData)
      .subscribe(
        (data) => {
          if (data.fileData) {
            Utils.downloadBase64File(data.fileData, 'FORM101_' + formData.docId, FileMimeType.PDF);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [MANAGER_GENERATE_FORM_101_AS_PDF]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.generateForm101AsPdf(formData)
      .subscribe(
        (data) => {
          if (data.body) {
            Utils.downloadBase64File(data.body, 'FORM101_' + formData.formId, FileMimeType.PDF);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [MANAGER_GET_MANUAL_FORM_101_AS_PDF]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.managerGetManualForm101AsPdf(formData)
      .subscribe(
        (data) => {
          if (data.fileData) {
            Utils.downloadBase64File(data.fileData, data.fileName, data.mimeType);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [GENERATE_EMPTY_FORM_101_AS_PDF]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formData: Form101DataModel,
  ) => {
    managerService.generateEmptyForm101AsPdf(formData)
      .subscribe(
        (data) => {
          if (data.body) {
            Utils.downloadBase64File(data.body, 'FORM101', FileMimeType.PDF);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [GENERATE_FORMS_SEARCH_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formsSearchRequest: FormsSearchRequest,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.generateFormsSearchReport(formsSearchRequest)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data) => {
          if (data.body) {
            Utils.downloadBase64File(data.body, 'formsSearch', FileMimeType.EXCEL);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [GENERATE_FORM_CHANGES_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    managerForm101Data: ManagerForm101Data,
  ) => {
    managerService.generateFormChangesReport(managerForm101Data)
      .subscribe(
        (data) => {
          if (data.body) {
            Utils.downloadBase64File(data.body, 'formChangesReport', FileMimeType.PDF);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.formDownloadErrorMessage'),
          });
        },
      );
  },

  [GENERATE_DETAILED_FORMS_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formsSearchRequest: FormsSearchRequest) => {
    managerService.generateDetailedFormsReport(formsSearchRequest)
      .subscribe(
        (data) => {
          if (data.body) {
            Utils.downloadBase64File(data.body, 'detailedFormsReport', FileMimeType.EXCEL);
          }
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('DETAILED_REPORT_EXPORT_ERROR'),
          });
        },
      );
  },

  [GET_CUBES_INFO]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.getCubesInfo()
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          commit(SET_CUBES_INFO, data.cubesInfoList);
          commit(SET_MASKIT_MODE, data.maskitMode);
          commit(SET_ADP_MODE, data.adpMode);
        },
        error => commit(SET_CUBES_INFO_ERRORS, error.messages),
      );
  },

  [GET_CUBE_DETAILS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    formsSearchRequest: FormsSearchRequest,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.getCubeDetails(formsSearchRequest)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data) => {
          const res = {
            results: data.cubesDetailsList,
            resultCount: data.noOfRows,
          };
          commit(SET_CUBE_DETAILS, res);
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [UPDATE_IPT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.updateIpt(cubesSelectedEmpsRequest)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.updateIptSuccess'),
          });
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [MARK_AS_IGNORE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.markAsIgnore(cubesSelectedEmpsRequest)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.markAsIgnoreSuccess'),
          });
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [UNDO_MARK_AS_IGNORE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.undoMarkAsIgnore(cubesSelectedEmpsRequest)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.undoMarkAsIgnoreSuccess'),
          });
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [UNDO_MARK_AS_UPDATE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.undoMarkAsUpdate(cubesSelectedEmpsRequest)
      .subscribe(data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.undoMarkAsUpdateSuccess'),
          });
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
          eventsHub.$root.$emit('clear-selected-rows');
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },


  [CREATE_MASKIT_UPDATE_FILE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.createMaskitUpdateFile(cubesSelectedEmpsRequest)
      .subscribe(
        (data: any) => {
          // eventsHub.$notify({
          //   group: 'frd',
          //   type: 'success',
          //   text: '' + eventsHub.$t('employees_update_details.undoMarkAsIgnoreSuccess'),
          // });
          Utils.downloadBase64File(data.body, 'CREATE_MASKIT_UPDATE_FILE', FileMimeType.TXT);
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [CREATE_ADP_UPDATE_FILE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    cubesSelectedEmpsRequest: CubesSelectedEmpsRequestModel,
  ) => {
    managerService.createAdpUpdateFile(cubesSelectedEmpsRequest)
      .subscribe(
        (data: any) => {
          Utils.downloadBase64File(data.fileData, data.fileName, FileMimeType.TXT);
          dispatch(GET_CUBE_DETAILS, cubesSelectedEmpsRequest.searchObject);
          eventsHub.$root.$emit('clear-selected-rows');
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
},
  [GENERATE_CUBE_DETAILS_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    compareResultSearchRequest: CompareResultSearchRequestModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.generateCubeDetailsReport(compareResultSearchRequest)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          if (data.body) {
            Utils.downloadBase64File(
              data.body, compareResultSearchRequest.groupType.toLowerCase(), FileMimeType.EXCEL,
            );
          }
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.exportToExcelSuccess'),
          });
        },
        error => commit(SET_CUBE_DETAILS_ERRORS, error.messages),
      );
  },

  [GENERATE_MANAGERS_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    indexNum: number,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.exportManagersByCustomer(indexNum)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          if (data.body) {
            Utils.downloadBase64File(
              data.body, `managerSettingsReport-${indexNum}`, FileMimeType.EXCEL,
            );
            eventsHub.$notify({
              group: 'frd',
              type: 'success',
              text: '' + eventsHub.$t('general.exportToExcelSuccess'),
            });
          } else {
            eventsHub.$notify({
              group: 'frd',
              type: 'error',
              text: '' + eventsHub.$t('general.exportToExcelFailed'),
            });
          }
        },

        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('general.exportToExcelFailed'),
          });
        },
      );
  },

  [GENERATE_COMPARE_RESULT_SEARCH_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    compareResultSearchRequest: CompareResultSearchRequestModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.generateCompareResultSearchReport(compareResultSearchRequest)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          if (data.body) {
            Utils.downloadBase64File(
              data.body, compareResultSearchRequest.groupType.toLowerCase() + '_search', FileMimeType.EXCEL,
            );
          }
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.exportDataToExcelSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.exportDataToExcelError'),
          });
        },
      );
  },

  [GENERATE_GROUP_TYPE_EXPORT_EVENTS_REPORT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    compareResultSearchRequest: CompareResultSearchRequestModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.generateGroupTypeExportEventsReport(compareResultSearchRequest)
      .pipe(
        finalize(() => commit(SET_MANAGER_LOADING, false)),
      )
      .subscribe(
        (data: any) => {
          if (data.body) {
            Utils.downloadBase64File(
              data.body, compareResultSearchRequest.groupType.toLowerCase() + '_events', FileMimeType.EXCEL,
            );
          }
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('employees_update_details.exportDataToExcelSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('employees_update_details.exportDataToExcelError'),
          });
        },
      );
  },

  [APPROVE_SELECTED_FORMS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    selectedForms: any[],
  ) => {
    commit(SET_OPEN_APPROVE_FORMS_MODAL_ERRORS, []);
    selectedForms = selectedForms.reduce((newSelectedForms, row) => {
      if (row.formId && row.formStatus === 20) {
        newSelectedForms.push({
          formId: row.formId,
          officeNum: row.employeeId.officeNum,
          idNum: row.employeeId.idNum,
          positionNum: row.employeeId.positionNum,
        });
      }
      return newSelectedForms;
    }, []);
    managerService.approveSelectedForms({ approveFormsList: selectedForms })
      .pipe(
        finalize(() => {
          commit(SET_MANAGER_LOADING, false);
          commit(SET_SELECTED_FORMS_TO_APPROVE, []);
        }),
      )
      .subscribe(
        (data: any) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.formsApproveModal.formsApproveModalSuccessfullyMessage'),
          });
          commit(SET_OPEN_APPROVE_FORMS_MODAL, false);
          dispatch(FORMS_SEARCH, state.form101SearchObject);
          eventsHub.$root.$emit('clear-selected-rows');
        },
        error => commit(SET_OPEN_APPROVE_FORMS_MODAL_ERRORS, error.messages),
      );
  },

  [APPROVE_ALL_FORMS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    commit(SET_OPEN_APPROVE_FORMS_MODAL_ERRORS, []);
    commit(SET_MANAGER_LOADING, true);
    commit(SET_OPEN_APPROVE_FORMS_MODAL, false);
    managerService.approveAllForms(state.form101SearchObject)
      .pipe(
        finalize(() => {
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data: any) => {
          if (state.formsResultData.resultCount === data.approvedCount) {
            eventsHub.$notify({
              group: 'frd',
              type: 'success',
              text: data.approvedCount + ' ' +
                eventsHub.$t('form101.wizard.formsApproveModal.formsApproveAllModalSuccessfullyMessage'),
            });
          } else {
            if (state.formsResultData.resultCount) {

              const notApproved = state.formsResultData.resultCount - data.approvedCount;
              eventsHub.$notify({
                group: 'frd',
                type: 'warning',
                text: ' ' + notApproved + ' ' +
                  eventsHub.$t('form101.wizard.formsApproveModal.formsApproveAllModalWarningMessage')
                  + ' ' + state.formsResultData.resultCount + ' ' +
                  eventsHub.$t('form101.wizard.formsApproveModal.formsApproveAllModalWarningMessageForms'),
              });
            }
            if (data.approvedCount) {
              eventsHub.$notify({
                group: 'frd',
                type: 'success',
                text: data.approvedCount + ' ' +
                  eventsHub.$t('form101.wizard.formsApproveModal.formsApproveAllModalWarningSuccessfullyMessage'),
              });
            }
          }

          dispatch(FORMS_SEARCH, state.form101SearchObject);
          eventsHub.$root.$emit('clear-selected-rows');
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: error.messages[0],
          });
          commit(SET_OPEN_APPROVE_FORMS_MODAL_ERRORS, error.messages);
        },
      );
  },

  [UPLOAD_MANUAL_FORM]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    { requestBody }: RequestPayload,
  ) => {
    commit(SET_OPEN_MANUAL_FORM_MODAL, false);
    commit(SET_MANAGER_LOADING, true);
    const newDoc: Document = {
      docName: requestBody.file.name,
      mimeType: requestBody.file.type,
      name: requestBody.file.name,
    };
    managerService.uploadManualForm(
      requestBody.file,
      requestBody.docType,
      requestBody.officeNum,
      requestBody.idNum,
      requestBody.positionNum,
      requestBody.taxYear)
      .subscribe(
        (data: any) => {

          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.uploadManualFormSuccessMessage'),
          });
          dispatch(FORMS_SEARCH, state.form101SearchObject);

        },
        (error: any) => {
          commit(SET_MANAGER_LOADING, false);
          commit(DOCUMENT_ROOT + SET_DOCUMENTS_ERRORS, error.messages, { root: true });
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.uploadManualFormErrorMessage'),
          });
        },
      );
  },

  [GET_MANAGER_DOCUMENT_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    { requestBody }: RequestPayload,
  ) => {
    const obj = {
      formId: requestBody.formId,
      officeNum: requestBody.officeNum,
      idNum: requestBody.idNum,
      positionNum: requestBody.positionNum,
    };
    managerService.getFormDocumentsList(obj)
      .subscribe(
        data => {
          commit(DOCUMENT_ROOT + SET_DOCUMENTS, data.documentList, { root: true });
        },
        (error: any) => {
          commit(DOCUMENT_ROOT + SET_DOCUMENTS_ERRORS, error.messages, { root: true });
        },
      );
  },

  [GET_MANAGER_DOCUMENT_CONTENT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    { requestBody }: RequestPayload,
  ) => {
    commit(SET_LOADING, true);
    const obj = {
      docId: requestBody.docId,
      officeNum: requestBody.officeNum,
      idNum: requestBody.idNum,
      positionNum: requestBody.positionNum,
    };
    managerService.getDocumentContent(obj)
      .pipe(
        finalize(() => commit(SET_LOADING, false)),
      )
      .subscribe(
        data => {
          Utils.downloadBase64File(data.body, requestBody.docName, requestBody.fileType);
        },
        (error: any) => {
          commit(DOCUMENT_ROOT + SET_DOCUMENTS_ERRORS, error.messages, { root: true });
        },
      );
  },

  [GET_CUBES_STATS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
  ) => {
    commit(SET_CUBES_STATS_LOADING, true);
    managerService.getCubesStats()
      .pipe(
        finalize(() => {
          commit(SET_CUBES_STATS_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(SET_CUBES_STATS, data);
        },
        error => commit(SET_CUBES_STATS_ERRORS, error.messages),
      );
  },

  [MANUAL_UPDATE_IPT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<ManagerState, RootState>,
    manualUpdateIptModel: Form101DataModel,
  ) => {
    commit(SET_MANAGER_LOADING, true);
    managerService.manualUpdateIpt(manualUpdateIptModel)
      .pipe(
        finalize(() => {
          commit(SET_MANAGER_LOADING, false);
        }),
      )
      .subscribe(
        (data) => {
          commit(SET_OPEN_MANUAL_UPDATE_IPT_MODAL, false);
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.manualUpdateIptModal.success'),
          });
          dispatch(FORMS_SEARCH, state.form101SearchObject);
        },
        error => commit(SET_MANUAL_UPDATE_IPT_MODAL_ERRORS, error.messages),
      );
  },

};
